import $ from 'jquery';
/**
 * Accessibility enhancements for the expert booking accordion
 * - Keyboard support (Enter/Space) for button trigger
 * - ARIA state management (aria-expanded sync)
 * - Screen reader announcements via aria-hidden on content region
 */
export function initAccessibility() {
    $(document).on('keydown', '.expert-booking-trigger', function (e) {
        const key = e.key || e.code;
        if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });
    $(document).on('click', '.expert-booking-trigger', function () {
        const $button = $(this);
        const controlsId = $button.attr('aria-controls');
        const $content = controlsId ? $('#' + controlsId) : $button.next('.expert-booking-content');
        setTimeout(() => {
            if (!$content || !$content.length)
                return;
            const isVisible = $content.is(':visible');
            $button.attr('aria-expanded', isVisible.toString());
            $content.attr('aria-hidden', (!isVisible).toString());
            if (isVisible) {
                const $slide = $button.closest('.slide');
                if ($slide.length) {
                    $slide.removeAttr('aria-hidden');
                }
            }
        }, 320);
    });
}
